// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-banner .snackbar{height:2.188rem;max-width:720px}@media screen and (max-width:768px){.cookie-banner .snackbar{height:auto;width:11.875rem;flex-direction:column;display:flex;align-self:auto!important}.cookie-banner .snackbar .action{display:flex;align-items:center;justify-content:space-around;width:100%}.cookie-banner .snackbar .bar{height:1px;width:100%;margin-top:11px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
